import React from "react";
import { MDXProvider } from "@mdx-js/react";
import PageIntlProvider from "./intl/PageIntlProvider";
import AnimatedFigure from "@app/components/AnimatedFigure";
import Quote from "@app/components/Quote";

export function wrapRootElement({ element }) {
  return (
    <PageIntlProvider>
      <MDXProvider
        children={element}
        components={{
          img: AnimatedFigure,
          blockquote: Quote,
        }}
      />
    </PageIntlProvider>
  );
}

export function wrapPageElement({ element, props }) {
  return (
    <PageIntlProvider langKey={props.pageContext.langKey}>
      <MDXProvider
        children={element}
        components={{
          img: AnimatedFigure,
        }}
      />
    </PageIntlProvider>
  );
}
